import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Twentyninetheme = ({get_data}) => {
    const navigate = useNavigate();
    const [cartCount, setCartCount] = useState(0);
    const [visibleCategories, setVisibleCategories] = useState(12);

    React.useEffect(() => {
        const updateCount = () => {
            const storedCart = localStorage.getItem('cart');
            const cartItems = storedCart ? JSON.parse(storedCart) : [];
            const count = cartItems.reduce((acc, item) => acc + (item.quantity || 1), 0);
            setCartCount(count);
        };

        updateCount();
        window.addEventListener('storage', updateCount);
        window.addEventListener('cartUpdated', updateCount);

        return () => {
            window.removeEventListener('storage', updateCount);
            window.removeEventListener('cartUpdated', updateCount);
        };
    }, []);

    const [cart, setCart] = useState([]);

        const addToCart = (service) => {
        const storedCart = localStorage.getItem('cart');
        let cartItems = storedCart ? JSON.parse(storedCart) : [];
        
        // Check if item already exists
        const existingItemIndex = cartItems.findIndex(item => 
            (item.id && service.id && item.id === service.id) || 
            (item.service_name && service.service_name && item.service_name === service.service_name)
        );
        
        if (existingItemIndex > -1) {
            cartItems[existingItemIndex].quantity = (cartItems[existingItemIndex].quantity || 1) + 1;
        } else {
            cartItems.push({ ...service, quantity: 1 });
        }

        localStorage.setItem('cart', JSON.stringify(cartItems));
        window.dispatchEvent(new Event('cartUpdated'));
        // alert(`Added ${service.service_name} to cart`);
        navigate('/cart');
    };

    return (
        <>
            <style>{`
        :root {
            /* Palette: Forest Floor */
            --moss: #3f6212;      /* Lime 800 */
            --leaf: #65a30d;      /* Lime 600 */
            --wood: #78350f;      /* Amber 900 */
            --dirt: #f7fee7;      /* Lime 50 */
            --stone: #a8a29e;
        }

        body { font-family: 'Bitter', serif; background: var(--dirt); color: var(--wood); margin: 0; }
        .container { max-width: 1000px; margin: 0 auto; padding: 0 40px; }
        
        .header { text-align: center; padding: 50px 0; border-bottom: 2px dashed var(--leaf); }
        .logo { font-size: 2.5rem; font-weight: 700; color: var(--moss); }
        .nav { margin-top: 20px; font-family: sans-serif; text-transform: uppercase; font-size: 0.8rem; letter-spacing: 1px; }
        .nav a { margin: 0 15px; color: var(--leaf); text-decoration: none; font-weight: 700; }
        
        .intro { padding: 80px 0; text-align: center; max-width: 600px; margin: 0 auto; }
        .intro h1 { font-size: 3rem; color: var(--moss); margin-bottom: 20px; }
        .intro p { font-size: 1.2rem; line-height: 1.8; color: #57534e; }
        
        .divider { display: flex; align-items: center; justify-content: center; margin: 40px 0; }
        .divider::before, .divider::after { content: ''; flex: 1; height: 1px; background: #d6d3d1; max-width: 200px; }
        .divider span { margin: 0 20px; color: var(--leaf); font-size: 1.5rem; }
        
        .services-grid { display: grid; grid-template-columns: 1fr; gap: 40px; }
        @media (min-width: 700px) { .services-grid { grid-template-columns: 1fr 1fr; } }
        
        .service-item { display: flex; gap: 20px; padding: 20px; background: white; border-radius: 12px; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05); }
        .service-icon { min-width: 60px; height: 60px; background: #ecfccb; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 1.5rem; color: var(--moss); }
        
        .products-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(250px, 1fr)); gap: 40px; }
        .product-card { background: white; border-radius: 12px; overflow: hidden; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05); transition: 0.3s; }
        .product-card:hover { transform: translateY(-5px); box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1); }
        .product-img { height: 200px; width: 100%; object-fit: cover; }
        
        .btn { background: var(--moss); color: white; border: none; padding: 10px 20px; border-radius: 6px; font-family: sans-serif; font-weight: 600; cursor: pointer; }
        .btn:hover { background: var(--leaf); }
        
        .footer { background: var(--moss); color: #ecfccb; padding: 60px 0; text-align: center; margin-top: 100px; }
            `}</style>
            
            <link href="https://fonts.googleapis.com/css2?family=Bitter:ital,wght@0,400;0,700;1,400&display=swap" rel="stylesheet" />

            <div className="header">
                <div className="container">
                    <div className="logo">{get_data.service_name}</div>
                    <div className="nav">
                        <a href="#services">Our Craft</a>
                        <a href="#products">Market</a>
                        <a href="#contact">Connect</a>
                        <a href="/cart" style={{display: 'flex', alignItems: 'center', position: 'relative', marginLeft: '15px', color: 'inherit', textDecoration: 'none'}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="9" cy="21" r="1"></circle>
                                <circle cx="20" cy="21" r="1"></circle>
                                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                            </svg>
                            {cartCount > 0 && (
                                <span style={{
                                    position: 'absolute',
                                    top: '-8px',
                                    right: '-10px',
                                    background: 'red',
                                    color: 'white',
                                    borderRadius: '50%',
                                    width: '20px',
                                    height: '20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '0.7rem',
                                    fontWeight: 'bold'
                                }}>
                                    {cartCount}
                                </span>
                            )}
                        </a>
                    </div>
                </div>
            </div>

            <div className="container intro">
                <h1>Grounded in Nature</h1>
                <p>We believe in organic growth and sustainable solutions. Rooted in quality, reaching for the sky.</p>
            </div>

            <div className="container" id="services">
                <div className="divider"><span>♣</span></div>
                <div className="services-grid">
                    {get_data.all_categories && get_data.all_categories.slice(0, visibleCategories).map((item, index) => (
                        <div className="service-item" key={index}>
                            <div className="service-icon">
                                {item.icon ? <img src={item.icon.startsWith('http') ? item.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${item.icon}`} style={{width: '35px', height: '35px'}} alt=""/> : <span>♠</span>}
                            </div>
                            <div>
                                <h3 style={{marginTop: 0, marginBottom: '10px'}}>{item.name}</h3>
                                <p style={{margin: '0 0 10px', fontSize: '0.9rem', color: '#57534e'}}>{item.description}</p>
                                <div style={{display: 'flex', gap: '10px'}}>
                                    <a href={`tel:${get_data.mobile}`} style={{color: 'var(--moss)', fontWeight: 'bold', fontSize: '0.8rem'}}>Call</a>
                                    <a href="#contact" style={{color: 'var(--leaf)', fontWeight: 'bold', fontSize: '0.8rem'}}>Enquire</a>
                                </div>
                            </div>
                        </div>
                    )) }
                    { get_data.all_categories && visibleCategories < get_data.all_categories.length && (
                        <div style={{textAlign: 'center', marginTop: '40px'}}>
                            <button 
                                onClick={() => setVisibleCategories(prev => prev + 6)} 
                                className="btn"
                            >
                                Show More
                            </button>
                        </div>
                    )}
                </div>
            </div>

            <div className="container" id="products">
                 <div className="divider"><span>♦</span></div>
                 <div className="products-grid">
                     {get_data.product_services && get_data.product_services.map((item, index) => (
                        <div className="product-card" key={index}>
                             {item.featured_image ? (<img src={item.featured_image && item.featured_image.startsWith('http') ? item.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`} className="product-img" alt={item.service_name}/>) : (<div className="product-img" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f0f0', fontSize: '1.5rem', fontWeight: 'bold', color: '#555',  }}>{(item.service_name || 'PR').slice(0, 2).toUpperCase()}</div>)}
                             <div style={{padding: '20px'}}>
                                 <h3 style={{fontSize: '1.2rem'}}>{item.service_name}</h3>
                                 {item.price && <div style={{color: 'var(--leaf)', fontWeight: 'bold', margin: '10px 0'}}>₹{item.price}</div>}
                                 <button onClick={() => addToCart(item)} className="btn" style={{width: '100%'}}>Add to Cart</button>
                             </div>
                        </div>
                     ))}
                 </div>
            </div>

            <footer className="footer" id="contact">
                <div className="container">
                    <h2 style={{color: 'white', marginBottom: '10px'}}>{get_data.service_name}</h2>
                    <p>{get_data.business_location_name}</p>
                    <p>{get_data.email}</p>
                </div>
            </footer>
        </>
    );
};

export default Twentyninetheme;
